module.exports = __webpack_public_path__ + "static/media/arrow.38d622d1.svg";